import React from 'react';
import { AlertTriangle, Mail } from 'lucide-react';

interface MaintenanceBannerProps {
  className?: string;
  variant?: 'inline' | 'card';
}

const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({ 
  className = '', 
  variant = 'inline' 
}) => {
  const baseStyles = variant === 'card' 
    ? 'bg-amber-50 border border-amber-200 rounded-lg p-4'
    : 'bg-amber-50/90 backdrop-blur-sm border border-amber-200 rounded-lg px-4 py-3';

  return (
    <div className={`${baseStyles} ${className}`}>
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-amber-800 text-sm font-medium">
            O Broker Base está temporariamente indisponível.
          </p>
          <p className="text-amber-700 text-sm mt-1">
            Para mais informações, entre em contato:{' '}
            <a 
              href="mailto:agilize.ai.contato@gmail.com" 
              className="text-blue-dark underline hover:text-blue-main font-medium inline-flex items-center gap-1"
            >
              <Mail className="h-3 w-3" />
              agilize.ai.contato@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
